export default {
  list: {
    name: "special share transfers list api",
    version: 6,
    url: "special-share-transfers",
    method: "GET",
  },
  sync: {
    name: "special share transfer sync api",
    version: 6,
    url: "special-share-transfers/%{id}/sync",
    method: "POST",
  },
};
